// extracted by mini-css-extract-plugin
module.exports = {"formLabel":"styles_formLabel__L49Is"};